import { FunctionComponent } from 'react';

import { Button } from '@kanda-libs/ks-design-library';

import { KandaEtikaBadge } from 'components';
import PleaseWaitOverlay from 'components/PleaseWaitOverlay';

import useReferred from './useReferred';

const Referred: FunctionComponent = () => {
  const { isLoading, showButton, link, provider, responseTime } = useReferred();
  return (
    <div className="flex flex-col">
      <PleaseWaitOverlay
        icon="alarm"
        header={provider === 'Etika' ? <KandaEtikaBadge /> : undefined}
        title={`Your application has been submitted to the lender, ${provider}`}
        labelLine1={`Your application is under review and you will receive updates here and via email. During regular working hours we'll have an update in ${responseTime} minutes.`}
        labelLine2={
          <p>
            If you&apos;re having trouble, you can reach out to Ideal4Finance
            loans team directly by clicking the{' '}
            <span className="font-semibold">&quot;Need Help&quot;</span> button
            in the header and calling our loans applications team to get some
            advice.
          </p>
        }
        labelLine3={
          showButton
            ? 'If you need to return to the lender, please click the below button'
            : undefined
        }
        isLoading={isLoading}
      />
      {showButton && (
        <a href={link} className="mx-auto mt-8">
          <Button.Text
            id="etika-lender-return"
            label="Return to lender"
            className="w-64"
            disabled={isLoading}
            isLoading={isLoading}
          />
        </a>
      )}
    </div>
  );
};

export default Referred;
